import React from 'react';
import './timePickerComponent.css';

const TimePickerComponentRender = (props) => {
  const {pickerRef, timesArray, selectedTimeInterval, setTime} = props;

  return (
    <div className="et-tp-n-time-picker-wrap" ref={pickerRef}>
      {timesArray.map((time, index) => (
        <div
          className={
            'et-tp-n-time-picker-row' +
            (selectedTimeInterval === time
              ? ' et-tp-n-time-picker-row-selected'
              : '')
          }
          onClick={() => setTime(time)}
          key={index}>
          <div
            className={
              'et-tp-tpr-n-time' +
              /* firstAvailableTimeSlot === time ||  */ (selectedTimeInterval ===
              time
                ? ' et-tp-tpr-n-time-selected'
                : '')
            }>
            {time}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TimePickerComponentRender;
